import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const TickIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M19.9806 5.99018C19.7208 5.99792 19.4742 6.1065 19.2931 6.29292L9.00008 16.5859L5.70712 13.2929C5.61497 13.1969 5.5046 13.1203 5.38247 13.0675C5.26034 13.0147 5.12891 12.9869 4.99587 12.9855C4.86283 12.9842 4.73086 13.0094 4.60768 13.0597C4.4845 13.1099 4.3726 13.1843 4.27852 13.2784C4.18444 13.3725 4.11008 13.4844 4.05979 13.6075C4.0095 13.7307 3.98429 13.8627 3.98565 13.9957C3.987 14.1288 4.01489 14.2602 4.06767 14.3823C4.12046 14.5045 4.19708 14.6148 4.29305 14.707L8.29305 18.707C8.4806 18.8944 8.73491 18.9998 9.00008 18.9998C9.26526 18.9998 9.51957 18.8944 9.70712 18.707L20.7071 7.70698C20.8516 7.56652 20.9503 7.38567 20.9903 7.18815C21.0302 6.99063 21.0096 6.78565 20.931 6.60007C20.8525 6.41448 20.7197 6.25695 20.5501 6.14812C20.3805 6.03929 20.182 5.98424 19.9806 5.99018Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

TickIcon.propTypes = {
  sx: PropTypes.object,
};

export default TickIcon;
